import React, { forwardRef } from "react";
import { Label } from "@/components/ui/label";
import {
  Select as RadixSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";

export interface SelectOption {
  label: string;
  value: string;
}

interface SelectProps {
  label?: string;
  name: string;
  options: SelectOption[];
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const Select = forwardRef<HTMLButtonElement, SelectProps>(
  (
    {
      label,
      name,
      options,
      value,
      onChange,
      onBlur,
      error,
      placeholder = "Bitte wählen",
      required,
      disabled,
      className,
    },
    ref
  ) => {
    return (
      <div className={className}>
        {label && (
          <Label className="block text-sm font-medium mb-1">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </Label>
        )}
        <RadixSelect
          value={value}
          onValueChange={onChange}
          disabled={disabled}
          name={name}
        >
          <SelectTrigger
            ref={ref}
            onBlur={onBlur}
            className={error ? "border-red-500 ring-1 ring-red-400" : ""}
          >
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </RadixSelect>
        {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
      </div>
    );
  }
);

Select.displayName = "Select";

export default Select;
